// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
require('./onbrand.scss'); // Onbrand styles
require('./client/client.scss'); // client styles
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); // Development options
// const htmlHeader = require('./includes/header.html'); // header replace with hub nav
// const htmlFooter = require('./includes/footer.html'); // footer place in CC
const { moveSearch, toggleSearch } = require('./partial-scripts/moveSearch');
const { mobileSocialWidget } = require('./partial-scripts/mobileSocialWidget');
const { scroll } = require('./partial-scripts/smoothScroll.js');
const {
  FaqHandler,
  controlExpandableContent,
  setUrlState,
} = require('./partial-scripts/expandableContent.js');

const { moveH1 } = require('./partial-scripts/moveH1.js');

// -- Startup -- //
if (!production) {
  onbrandUtilityFunctions.devMode(devOptions);
}
window.onbrandLoaded = false;
// $('body').prepend(htmlHeader); // header replaced with hub nav
// $('body').append(htmlFooter); // footer placed in CC

// old time embed error throw "fix" (TODO: make this better)
onbrandUtilityFunctions.legacyEmbedTileFix();
// Remove the "touch" class on touchscreen laptops
onbrandUtilityFunctions.removeTouchForLaptops();
// Remove the hub function updateOverlaySize
onbrandUtilityFunctions.overrideHubFuctions();
// Adds body classes for content type (blogPost, youtube, sales-stream etc)
onbrandUtilityFunctions.helpfulClasses();
// Rebuild the share widget for the top-nav
onbrandUtilityFunctions.fixShareWidgetImproved();
// warns you if your query string is missing.
onbrandUtilityFunctions.noQueryStringSafeguard();
// makes the reco engine sticky to the target / top of screen
onbrandUtilityFunctions.recoEnginePositioning('.top-nav');
// Pre hub event hub events (Note: disabled by default)
// onbrandUtilityFunctions.legacyEvents();

// -- Custom Functions -- //

// -- Hub Events -- //
const onLoadAndPageChange = function() {
  onbrandUtilityFunctions.blockCtaFix();
  onbrandUtilityFunctions.fadeOutItem();
};

Hubs.Events.on('load', () => {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();
    moveH1();
    controlExpandableContent();
    if ($('.level-1').length > 0) {
      setUrlState();
    }
    FaqHandler();
    moveSearch();
    toggleSearch();
    mobileSocialWidget();
    scroll();
    $('.ob-slider').slick({
      autoplay: true,
      dots: true,
      infinite: true,
      autoplaySpeed: 4500,
    });
    // Add your onloads here...

    // end your onloads before here...
    window.onbrandLoaded = true;
  }
})
  .on('pageChange', () => {
    onLoadAndPageChange();
  })
  .on('itemsLoaded', (itemIds, selectors) => {}) //eslint-disable-line no-unused-vars
  .on('resize', () => {
    onbrandUtilityFunctions.sideCtaFix();
    onbrandUtilityFunctions.addThisFix();
    mobileSocialWidget();
  })
  .on('scroll', () => {
    onbrandUtilityFunctions.sideCtaFix();
    onbrandUtilityFunctions.addThisFix();
    onbrandUtilityFunctions.blockCtaFix();
    onbrandUtilityFunctions.fadeOutItem();
  })
  .on('ctaActivate', (ctaId) => {}) //eslint-disable-line no-unused-vars
  .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {}) //eslint-disable-line no-unused-vars
  .on('search', () => {});

// The new hub events can trigger before cihost scripts are loaded.
// This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger('load');
}



// WEBPACK FOOTER //
// ./onbrand.js